import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router';
import { Layout } from '../../components/Layout.js';
import { Seo } from '../../components/Seo.js';
import { MagicLinkForm } from './MagicLinkForm.js';

export function LoginPage() {
  const { t } = useTranslation('auth');
  const { lang } = useParams();
  const locale = (lang as 'es' | 'en') ?? 'es';

  return (
    <Layout>
      <Seo title={t('login.title')} description={t('login.subtitle')} locale={locale} noindex />
      <div className="max-w-md mx-auto px-4 pt-20 pb-16">
        <h1 className="text-3xl font-bold mb-2">{t('login.title')}</h1>
        <p className="text-neutral-400 mb-8">{t('login.subtitle')}</p>
        <MagicLinkForm submitLabel={t('login.submit')} intent="login" />
        <p className="text-sm text-neutral-500 mt-8 text-center">
          {t('login.no_account')}{' '}
          <Link to={`/${lang}/auth/signup`} className="text-[var(--color-accent)] hover:underline">
            {t('login.start_free')}
          </Link>
        </p>
      </div>
    </Layout>
  );
}
